@if (position) {
  @if (showCheckboxes) {
    <td class="relative px-7 sm:w-12 sm:px-6">
      <input
        type="checkbox"
        disabled
        class="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-edge-strong text-indigo-600 focus:ring-indigo-600"
      />
    </td>
  }
  <td
    class="whitespace-nowrap py-3 pr-3 text-sm font-medium text-fg-primary"
    [class.pl-3]="!showCheckboxes"
  >
    {{ position.displayName }}
    <app-badge class="ml-2" color="green">Coming Soon</app-badge>
  </td>
  <td class="whitespace-nowrap px-3 py-4 text-sm text-fg-secondary"></td>
  <td class="whitespace-nowrap px-3 py-4 text-sm text-fg-secondary">Fixpreis</td>
  <td class="whitespace-nowrap px-3 py-0 text-sm text-fg-secondary text-right tabular-nums">
    <app-number-input [isDisabled]="true" class="block max-w-40 ml-auto" variant="currency">
      /></app-number-input
    >
  </td>
  <td class="whitespace-nowrap px-3 py-4 text-sm text-fg-secondary text-right"></td>
  <td
    class="whitespace-nowrap px-3 py-4 text-sm font-medium text-fg-secondary text-right tabular-nums"
  ></td>
  @if (!showCheckboxes) {
    <td class="whitespace-nowrap px-3 py-4">
      <div class="flex items-center justify-end">
        <button
          [disabled]="isDisabled"
          class="flex items-center text-fg-faint hover:text-fg-subtle disabled:hover:text-fg-faint"
          (click)="deletePosition.emit(position)"
        >
          <app-ng-icon name="heroTrash"></app-ng-icon>
        </button>
      </div>
    </td>
  }
}
